import React, { useState, useEffect, useContext } from "react";
import { AxiosInstance } from "../axios";

export const CartContext = React.createContext();

const CartItemsContextProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  useEffect(() => {
    if (userid) {
      cartNotify(userid); // Call cartNotify on component refresh
    } else {
      setCartItems([]); // Clear cart for guest users
    }
  }, []); // Dependency array ensures it runs when userId changes
  // Sync the fetched cartList with context state
  const cartNotify = async (usesrId) => {
    try {
      const updatedCart = await AxiosInstance.post("api/book/cart/list", {
        user_id: usesrId,
      });

      if (updatedCart?.data?.status) {
        setCartItems(updatedCart?.data?.data); // Update context state
      } else {
        setCartItems([]); // Update context state
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };

  const cartdeleteNotify = async (id) => {
    setCartItems(cartItems.filter((item) => item.id !== id));
  };

  return (
    <CartContext.Provider value={{ cartItems, cartNotify, cartdeleteNotify }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartItemsContextProvider;
